import { useState } from "react";
import {
  FileBadge2,
  FileInput,
  FileSignature,
  FolderArchive,
  Handshake,
  HardHat,
  Home,
  ListChecks,
  Menu,
  ReceiptText,
  Settings,
  Users,
  WalletCards,
  X
} from "lucide-react";

const primary = [
  { id: "dashboard", label: "Início", icon: Home },
  { id: "financeiro/contas-receber", label: "Receber", icon: WalletCards },
  { id: "financeiro/contas-pagar", label: "Pagar", icon: ReceiptText },
  { id: "novo-negocio", label: "Contrato", icon: Handshake }
];

const more = [
  { id: "financeiro/visao-geral", label: "Financeiro", icon: WalletCards },
  { id: "financeiro/movimentacoes", label: "Movimentações", icon: FileInput },
  { id: "financeiro/conciliacao", label: "Conciliação bancária", icon: ListChecks },
  { id: "clientes", label: "Clientes", icon: Users },
  { id: "contratos", label: "Contratos", icon: FileSignature },
  { id: "obras", label: "Obras", icon: HardHat },
  { id: "notas-fiscais", label: "Notas Fiscais", icon: FileBadge2 },
  { id: "documentos", label: "Documentos", icon: FolderArchive },
  { id: "configuracoes/aplicativo", label: "Configurações", icon: Settings }
];

export function MobileNavigation({ route, onNavigate }: { route: string; onNavigate: (route: string) => void }) {
  const [open, setOpen] = useState(false);
  const navigate = (next: string) => {
    setOpen(false);
    onNavigate(next);
  };
  const moreActive = more.some((item) => route === item.id || route.startsWith(`${item.id}/`));

  return <>
    {open && <div className="mobile-more-backdrop" role="presentation" onClick={() => setOpen(false)}>
      <section className="mobile-more-sheet" role="dialog" aria-modal="true" aria-label="Mais opções" onClick={(event) => event.stopPropagation()}>
        <header><div><span>CCE Gestão</span><strong>Mais opções</strong></div><button onClick={() => setOpen(false)} aria-label="Fechar mais opções"><X size={22}/></button></header>
        <nav>{more.map((item) => <button key={item.id} className={route === item.id || route.startsWith(`${item.id}/`) ? "active" : ""} onClick={() => navigate(item.id)}><item.icon size={21}/><span>{item.label}</span></button>)}</nav>
      </section>
    </div>}
    <nav className="mobile-bottom-nav" aria-label="Navegação principal no celular">
      {primary.map((item) => <button key={item.id} className={route === item.id ? "active" : ""} onClick={() => navigate(item.id)}><item.icon size={21}/><span>{item.label}</span></button>)}
      <button className={open || moreActive ? "active" : ""} onClick={() => setOpen((current) => !current)} aria-expanded={open}><Menu size={21}/><span>Mais</span></button>
    </nav>
  </>;
}
